import { Geometry } from '../core/Geometry.js';
export class Triangle extends Geometry {
  constructor(gl) {
    let {
      attributes = {}
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Object.assign(attributes, {
      position: {
        size: 2,
        data: new Float32Array([-1, -1, 3, -1, -1, 3])
      },
      uv: {
        size: 2,
        data: new Float32Array([0, 0, 2, 0, 0, 2])
      }
    });
    super(gl, attributes);
  }
}